import { sidebarChildrenType, sidebarItemType, sidebarMenuType, subChildrenType } from "Types/LayoutDataType";
import { Modul } from "Types/OSM/Modul";

export const OSMtoMenu = function (data: Modul[]) {
    return data.map(item => mapMenuItem(item));
}


function mapMenuItem(item: any): sidebarItemType {
    const hasChildren = Array.isArray(item.child) && item.child.length > 0;

    if (hasChildren) {
        return {
            id: item.id,
            title: item.display,
            icon: item.icon || "default-icon",
            type: "sub",
            pathSlice: item.nama,
            active: false,
            bookmark: false,
            children: item.child.map((child: any) => mapSubItem(child))
        };
    } else {
        return {
            id: item.id,
            title: item.display,
            icon: item.icon || "default-icon",
            type: "link",
            path: `/${item.nama}`,
            active: false,
            bookmark: false
        };
    }
}

function mapSubItem(item: any): sidebarChildrenType {
    const hasChildren = Array.isArray(item.child) && item.child.length > 0;
    if (hasChildren) {
        return {
            title: item.display,
            type: "sub",
            path: item.nama,
            bookmark: false,
            children: item.child.map((child: any) => mapSubItem(child))
        };
    } else {
        return {
            title: item.display,
            type: "link",
            path: `/${item.nama}`,
            bookmark: false
        };
    }
}